// extracted by mini-css-extract-plugin
export default {"container":"Points_container__cAmED"};